
import { i18nText } from '@/locales';
import {Form} from "@/form/form";
import {Validate} from "@/plugins/Vuelidate/Decorators";
import {numeric, required, requiredIf} from "vuelidate/lib/validators";
import {Component} from "vue-property-decorator";
import {CashboxTransferFormRequestType} from "@/form/finance/cashbox/CashboxTransferForm.types";
import { fio, email } from "@/utils/validators";
import {ICashboxListItem} from "@/entity/finance/cashbox/cashbox.types";

@Component
export default class CashboxTransferForm extends Form{
    @Validate(required, i18nText("Выберите кассу"))
    from = 1;
    @Validate(required, i18nText("Выберите кассу"))
    to: number | null = 2;
    @Validate(required, i18nText("Введите баланс"))
    sum: string | number = 0;
    comment: string | null = '';
    cashboxes: ICashboxListItem[] = [];
    
    getFormData(): CashboxTransferFormRequestType {
        return {
            from: this.from,
            to: this.to,
            sum: this.sum,
            comment: this.comment,
        }
    }
    setFormData(cashboxes: ICashboxListItem[], from: number, to?: number | null): void {
        this.cashboxes = [];
        this.from = from;
        if(to){
            this.to = to;
        }
        for (let i = 0; i < cashboxes.length; i++) {
            this.cashboxes.push(cashboxes[i]);
        }
    }
}
